import React, { useState, useEffect } from 'react';
import api from './utils/api'; 
import Navbar from './components/Navbar'; 

export default function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  
  // Inisialisasi formData di atas sebelum digunakan
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    role: 'admin'
  });

  // 1. Ambil Data User dari Backend
  const fetchUsers = async () => {
    try {
      // Pastikan menggunakan prefix /api jika backend memintanya
      const response = await api.get('/api/users'); 
      setUsers(response.data);
    } catch (err) {
      console.error("Gagal mengambil data user", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // 2. Fungsi Simpan User Baru
  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("Data Yang dikirim", formData); // Debugging
    try {
      // Sesuai dengan route backend: /api/users/register
      await api.post('/api/users/register', formData); 
      alert('Admin Baru Berhasil Ditambahkan!');
      setShowModal(false);
      setFormData({ name: '', email: '', password: '', role: 'admin' });
      fetchUsers(); // Refresh tabel
    } catch (err) {
      alert(err.response?.data?.message || 'Gagal menambah admin');
    }
  };

  // 3. Fungsi Hapus User
  const deleteUser = async (id) => {
    if (window.confirm('Yakin ingin menghapus admin ini?')) {
      try {
        await api.delete(`/api/users/${id}`);
        fetchUsers();
      } catch (err) {
        alert('Gagal menghapus user');
      }
    }
  };

  if (loading) return <div className="p-10 text-center">Loading...</div>;

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="max-w-6xl mx-auto p-6">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Admin Management</h1>
          <button 
            onClick={() => setShowModal(true)}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg shadow-md transition"
          >
            + Add New Admin
          </button>
        </div>

        {/* Tabel User */}
        <div className="bg-white rounded-xl shadow overflow-hidden">
          <table className="w-full text-left border-collapse">
            <thead className="bg-gray-100 text-gray-600 uppercase text-sm">
              <tr>
                <th className="p-4">Name</th>
                <th className="p-4">Email</th>
                <th className="p-4">Role</th>
                <th className="p-4 text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {users.length > 0 ? users.map((user) => (
                <tr key={user._id} className="border-t hover:bg-gray-50 transition">
                  <td className="p-4 font-medium">{user.name}</td>
                  <td className="p-4 text-gray-600">{user.email}</td>
                  <td className="p-4">
                    <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded text-xs uppercase font-bold">
                      {user.role}
                    </span>
                  </td>
                  <td className="p-4 text-center">
                    <button 
                      onClick={() => deleteUser(user._id)}
                      className="text-red-500 hover:text-red-700 font-medium"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="4" className="p-4 text-center text-gray-500">No admins found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Modal Form Tambah Admin */}
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6">
              <h2 className="text-xl font-bold mb-4 text-gray-800">Create Admin Account</h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">Full Name</label>
                  <input 
                    type="text" required className="w-full border p-2 rounded-lg mt-1 outline-blue-500"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Email Address</label>
                  <input 
                    type="email" required className="w-full border p-2 rounded-lg mt-1 outline-blue-500"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Phone Number</label>
                  <input 
                    type="text" required className="w-full border p-2 rounded-lg mt-1 outline-blue-500"
                    placeholder="Contoh: 08123456789"
                    value={formData.phone}
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Password</label>
                  <input 
                    type="password" required className="w-full border p-2 rounded-lg mt-1 outline-blue-500"
                    value={formData.password}
                    onChange={(e) => setFormData({...formData, password: e.target.value})}
                  />
                </div>
                <div className="flex justify-end gap-3 mt-6">
                  <button 
                    type="button" onClick={() => setShowModal(false)}
                    className="px-4 py-2 text-gray-500 hover:bg-gray-100 rounded-lg"
                  >
                    Cancel
                  </button>
                  <button 
                    type="submit"
                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 shadow-md"
                  >
                    Save Admin
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}